import { Player } from '@lottiefiles/react-lottie-player';
import { styled } from '@mui/material';

import {
  ANIMATION_MAP,
  NON_BRANDABLE_ANIMATIONS,
} from './ChkLottieAnimation.constants';
import type { LottieAnimationProps } from './ChkLottieAnimation.types';
import { useLottieAnimationPrefersReducedMotion } from './useLottieAnimationPrefersReducedMotion';

export const ChkLottieAnimation = ({
  src,
  children,
  loop = true,
}: LottieAnimationProps) => {
  const animationSrc = ANIMATION_MAP[src];
  const isBrandable = !NON_BRANDABLE_ANIMATIONS.includes(src);
  const { playerRef, handleEvent, speed } =
    useLottieAnimationPrefersReducedMotion(src);

  return (
    <StyledPlayer
      ref={playerRef}
      onEvent={handleEvent}
      isBrandable={isBrandable}
      autoplay
      keepLastFrame
      loop={loop}
      src={animationSrc}
      speed={speed}
    >
      {children}
    </StyledPlayer>
  );
};

const StyledPlayer = styled(Player)<{ isBrandable: boolean }>(
  ({ theme, isBrandable }) => ({
    ...(isBrandable && {
      [`path[stroke]`]: {
        stroke: theme.tokens.lottieAnimationStroke,
      },
    }),
  })
);
